<template>
  <div class="main-container">
    <router-view></router-view>

    <!-- Navbar section -->
    <HeaderStartup />

    <!-- hero section -->
    <HeroStartup />

    <!-- service area  -->
    <CurveShape class="no-height">
      <template v-slot:bgcolor>
        <path
          style="fill: #ffffff; stroke-miterlimit: 10"
          d="M3360.5,97.739c-242,0-480-48.375-480-48.375
                        S2647.5,0.5,2400.5,0.5s-480,48.375-480,48.375s-238,48.864-480,48.864s-480-48.375-480-48.375S727.5,0.5,480.5,0.5
                        S0.5,48.875,0.5,48.875V108h1920h1920V48.875C3840.5,48.875,3602.5,97.739,3360.5,97.739z"
        />
      </template>
    </CurveShape>
    <div class="start-ups-feature startup-about-feature section-space--pt_120" id="about">
      <div class="container">
        <div class="section-title-wrapper text-center section-space--mb_60">
          <h2 class="section-title mb-30 wow move-up">
            Pixel started in March, 2021 with a simple vision: to build and deliver long-term value
            to the burgeoning NFT industry.
          </h2>
          <div class="video-button-container video-popup wow move-up">
            <div class="video-play">
              <span class="video-text"
                >In a sector filled with copycats and cash grabs for jpegs, we sought to do
                something original, and build in a way that honors our customers. Our first project,
                PixelPotus, grew organically from a few users to several thousand in just a few
                months' time and now sits in the top five apps on
                <a
                  href="https://dappradar.com/rankings/protocol/tezos"
                  target="_blank"
                  class="hover-style-link hover-style-link--green"
                  >DappRadar</a
                >
                for Tezos. Our recent token launch, $PXL, was 5x oversubscribed in its IFO,
                demonstrating the Tezos community's strong agreement with our vision. <br />
                <br />We are so thankful and excited to keep building the next wave of zany,
                creative collectibles with you all!</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tabs-wrapper startup-tab section-space--mt_30 section-space--pb_120" id="projects">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-title-wrapper text-center section-space--mb_60 wow move-up">
              <h2 class="section-title font-weight--bold mb-15">Pixel Projects</h2>

              <div class="tab-mission-wrap section-space--mt_60">
                <div class="row align-items-center">
                  <div class="col-lg-7">
                    <div class="tab-mission-image">
                      <img src="../assets/img/other/level-up.png" alt="image" class="img-fluid" />
                    </div>
                  </div>
                  <div class="col-lg-5">
                    <div class="tab-content-inner">
                      <h4 class="font-weight--light" style="">PixelPotus</h4>
                      <h6 class="sub-heading">Collectible NFT Competition</h6>
                      <p class="dec section-space--mt_40 section-space--mb_40">
                        <a
                          class="hover-style-link hover-style-link--green"
                          href="https://www.pixelpotus.com"
                          target="_blank"
                          >PixelPotus</a
                        >
                        is a collectible NFT competition built on the Tezos blockchain. There are 45
                        presidents with six different rarities for each, with custom artwork for
                        each president at each level. Users can claim one free POTUS each day!
                      </p>
                      <div class="tab-button section-space--mb_40">
                        <a
                          class="ht-btn ht-btn-md"
                          href="https://www.pixelpotus.com"
                          target="_blank"
                          >Try PixelPotus</a
                        >
                      </div>
                      <h6 class="sub-heading">
                        What’s next with PixelPotus?
                        <a
                          href="https://pixelpotus.medium.com/pixelpotus-whats-next-23a54eaa7ed8"
                          target="_blank"
                          class="hover-style-link hover-style-link--green"
                          >Learn more</a
                        >
                      </h6>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tab-mission-wrap section-space--mt_60">
                <div class="row align-items-center">
                  <div class="col-lg-5">
                    <div class="tab-content-inner">
                      <h4 class="font-weight--light" style="">PixelDebates</h4>
                      <h6 class="sub-heading">NFT-Based Trading Card Game</h6>
                      <p class="dec section-space--mt_40 section-space--mb_40">
                        PixelDebates is an NFT-powered TCG in the spirit of classics like MtG or
                        Hearthstone (no affiliation). Players collect and build a deck of tactics
                        cards and engage in PvP battles where they can earn $PXL.
                      </p>
                      <div class="tab-button section-space--mb_40">
                        <a
                          class="ht-btn ht-btn-md"
                          href="https://www.pixeldebates.com"
                          target="_blank"
                          >Collect Tactics</a
                        >

                        <a
                          class="ht-btn ht-btn-md mt-3"
                          href="https://play.pixeldebates.com"
                          target="_blank"
                          >Play PixelDebates</a
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-7">
                    <div class="tab-mission-image">
                      <img src="../assets/img/other/04_GameBG.jpg" alt="image" class="img-fluid" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="tab-mission-wrap section-space--mt_60" style="">
                <div class="row align-items-center">
                  <div class="col-lg-7">
                    <div class="tab-mission-image">
                      <img src="../assets/img/other/tezerfly.png" alt="image" class="img-fluid" />
                    </div>
                  </div>
                  <div class="col-lg-5">
                    <div class="tab-content-inner">
                      <h4 class="font-weight--light" style="">Tezerfly</h4>
                      <h6 class="sub-heading">Gamified NFT Crowdsale</h6>
                      <p class="dec section-space--mt_40 section-space--mb_40">
                        <a href="https://www.tezerfly.xyz" target="_blank">Tezerfly</a> is a
                        gamified crowdsale with 101 butterfly egg varieties which can be hatched
                        into caterpillars and pupated into a new generation of unique baby
                        butterflies!
                      </p>
                      <div class="tab-button section-space--mb_40">
                        <a class="ht-btn ht-btn-md" href="https://www.tezerfly.xyz" target="_blank"
                          >Hatch Some Eggs</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tab-mission-wrap section-space--mt_60">
                <div class="row align-items-center">
                  <div class="col-lg-5">
                    <div class="tab-content-inner">
                      <h4 class="font-weight--light" style="">PixelPower</h4>
                      <h6 class="sub-heading">Collectible NFT Competition</h6>
                      <p class="dec section-space--mt_40 section-space--mb_40">
                        PixelPower is a high-caliber NFT competition built on the tezos blockchain.
                        Players compete to collect 50+ NFT weapons with 6 levels of rarity, build
                        their firepower and earn rewards. Start claiming today at
                        www.pixelpower.xyz.
                      </p>
                      <div class="tab-button section-space--mb_40">
                        <a
                          class="ht-btn ht-btn-md"
                          href="https://www.pixelpower.xyz"
                          target="_blank"
                          >Build Your FirePower</a
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-7">
                    <div class="tab-mission-image">
                      <img
                        src="https://pixelgames.mypinata.cloud/ipfs/QmVHAxB2cwy1jUbaKMziRQk4LBuxQo1oD9zZooy2g2BaeB"
                        alt="image"
                        class="img-fluid"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="tab-mission-wrap section-space--mt_60" style="">
                <div class="row align-items-center">
                  <div class="col-lg-7">
                    <div class="tab-mission-image">
                      <img
                        src="https://www.prjktneon.xyz/images/LOREPAGES.gif"
                        alt="image"
                        class="img-fluid"
                      />
                    </div>
                  </div>
                  <div class="col-lg-5">
                    <div class="tab-content-inner">
                      <h4 class="font-weight--light" style="">PRJKTNEON FILES</h4>
                      <h6 class="sub-heading">NFT Crafting Adventure</h6>
                      <p class="dec section-space--mt_40 section-space--mb_40">
                        <a href="https://www.prjktneon.xyz/" target="_blank">PRJKTNEON</a>
                        is a collection of 666 programmatically, randomly generated cyberpunk
                        characters called AVATARS that live on the Tezos blockchain. They have lots
                        of features (137 traits total) with different rarities, and give their
                        owners access to exclusive benefits on top of being absolutely badass.
                        <br /><br />
                        <a href="https://objkt.com/collection/prjktneonfiles" target="_blank"
                          >PRJKTNEON FILES</a
                        >
                        is the companion project where lore, special characters and other
                        collectibles will be minted for the benefits of the collectors.
                      </p>
                      <div class="tab-button section-space--mb_40">
                        <a
                          class="ht-btn ht-btn-md"
                          href="https://objkt.com/collection/prjktneonfiles"
                          target="_blank"
                          >Collect FILES</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="tab-mission-wrap section-space--mt_60">
                <div class="row align-items-center">
                  <div class="col-lg-5">
                    <div class="tab-content-inner">
                      <h4 class="font-weight--light" style="">
                        Pixel Swag
                      </h4>
                      <h6 class="sub-heading">
                        Physical swag featuring your favorite NFTs
                      </h6>
                      <p class="dec section-space--mt_40 section-space--mb_40">
                        PixelSwag.co .
                      </p>
                      <div class="tab-button section-space--mb_40">
                        <a class="ht-btn ht-btn-md" href="https://www.pixelpotus.com" target="_blank">Get Shwifty</a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-7">
                    <div class="tab-mission-image">
                      <img
                        src="../assets/img/other/pixelswag.jpg"
                        alt="image"
                        class="img-fluid"
                      />
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- pxl component -->
    <div class="team-member-wrapper section-space--ptb_60 section-dark" id="pxl">
      <div class="container">
        <div class="tab-history-wrap section-space--mt_80">
          <div class="row justify-content-center">
            <div class="col-lg-3">
              <div class="tab-history-image">
                <img src="../assets/img/logo/pxl_logo.png" alt="" class="img-fluid" />
              </div>
            </div>
            <div class="col-lg-5">
              <div class="tab-content-inner">
                <h2 class="section-title font-weight--bold mb-15">$PXL Token</h2>
                <div class="heading mb-30">
                  $PXL is the utility token of the Pixel ecosystem. It is used to pay for in-game
                  assets, perks and services offered in our projects.
                </div>
                <ul class="check-list green-check-list section-space--mb_30">
                  <li class="list-item">Launched Nov 1st, 2021</li>
                  <li class="list-item">Over 5x oversubscribed in our IFO</li>
                  <li class="list-item">
                    <a
                      href="https://quipuswap.com/swap/tez-KT1F1mn2jbqQCJcsNgYKVAQjvenecNMY2oPK_0"
                      target="_blank"
                      class="hover-style-link hover-style-link--green"
                      >Available on Quipuswap</a
                    >
                  </li>
                </ul>
                <div class="tab-button">
                  <a
                    href="https://quipuswap.com/swap/tez-KT1F1mn2jbqQCJcsNgYKVAQjvenecNMY2oPK_0"
                    target="_blank"
                    class="ht-btn ht-btn-md"
                    >Get $PXL
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="tab-history-wrap section-space--mt_80">
          <div class="row justify-content-center">
            <div class="col-lg-3">
              <div class="tab-history-image">
                <img src="../assets/img/logo/pxldao_logo.png" alt="" class="img-fluid" />
              </div>
            </div>
            <div class="col-lg-5">
              <div class="tab-content-inner">
                <h2 class="section-title font-weight--bold mb-15">$pxlDAO Token</h2>
                <div class="heading mb-30">
                  $pxlDAO will be used for voting on the direction of Pixel-based projects (voting
                  targeted for Q2, 2022).
                </div>
                <ul class="check-list green-check-list section-space--mb_30">
                  <li class="list-item">Launched Nov 1st, 2021</li>
                  <li class="list-item">
                    You can farm $pxlDAO on
                    <a
                      href="https://app.crunchy.network/#/farms?q=pxl"
                      target="_blank"
                      class="hover-style-link hover-style-link--green"
                      >Crunchy
                    </a>
                  </li>
                  <li class="list-item">
                    <a
                      href="https://quipuswap.com/swap/tez-KT1VQG4kZR6FkF8jppegp8cGhjJF66jJejLf_0"
                      target="_blank"
                      class="hover-style-link hover-style-link--green"
                      >Available on Quipuswap</a
                    >
                  </li>
                </ul>
                <div class="tab-button">
                  <a
                    href="https://quipuswap.com/swap/tez-KT1VQG4kZR6FkF8jppegp8cGhjJF66jJejLf_0"
                    target="_blank"
                    class="mb-2 mb-md-0 ht-btn ht-btn-md"
                    >Get $pxlDAO
                  </a>
                  <a
                    href="https://app.crunchy.network/#/farms?q=pxl"
                    target="_blank"
                    class="ml-0 ml-md-2 ht-btn ht-btn-md"
                    >Farm $pxlDAO
                  </a>
                </div>
                <div class="tab-button"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- contact form section -->
    <!-- <ContactForm /> -->
    <div class="section-space--ptb_120 bg-gray-3" id="contact">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="digital-agency-section-title text-center section-space--mb_60">
              <h3 class="section-title font-weight--light mb-15 wow move-up">
                Want to make your next <br />
                project <i>pixel-powered</i>? Contact us.
              </h3>
            </div>
            <!-- newsletter text -->
            <h4 class="sub-heading text-center wow move-up">
              <a href="mailto:powerup@pxl.limited" class="hover-style-link hover-style-link--green"
                >powerup@pxl.limited</a
              >
            </h4>
          </div>
        </div>
      </div>
    </div>

    <!-- footer section -->
    <FooterMain FooterStyle="bg_drak-footer" />
  </div>
</template>

<script>
import CurveShape from '../components/CurveShape'
// import ContactForm from "../components/ContactForm";
import FooterMain from '../components/FooterMain'
import HeaderStartup from '../components/HeaderStartup'
import HeroStartup from '../components/HeroStartup'

export default {
  name: 'app',
  components: {
    HeaderStartup,
    HeroStartup,
    CurveShape,
    // ContactForm,
    FooterMain,
  },
  data() {
    return {}
  },
  metaInfo: {
    title: 'Pixel | Games & Defi',
    htmlAttrs: {
      lang: 'en',
      amp: true,
    },
  },
}
</script>
